const COUNTRY_CODES = [
    {
      "country": "Afghanistan",
      "iso2": "AF",
      "calling_code": "+93",
      "mobile_digits": "9"
    },
    {
      "country": "Albania",
      "iso2": "AL",
      "calling_code": "+355",
      "mobile_digits": "9"
    },
    {
      "country": "Algeria",
      "iso2": "DZ",
      "calling_code": "+213",
      "mobile_digits": "9"
    },
    {
      "country": "Andorra",
      "iso2": "AD",
      "calling_code": "+376",
      "mobile_digits": "6"
    },
    {
      "country": "Angola",
      "iso2": "AO",
      "calling_code": "+244",
      "mobile_digits": "9"
    },
    {
      "country": "Antigua and Barbuda",
      "iso2": "AG",
      "calling_code": "+1268",
      "mobile_digits": "10"
    },
    {
      "country": "Argentina",
      "iso2": "AR",
      "calling_code": "+54",
      "mobile_digits": "10"
    },
    {
      "country": "Armenia",
      "iso2": "AM",
      "calling_code": "+374",
      "mobile_digits": "8"
    },
    {
      "country": "Australia",
      "iso2": "AU",
      "calling_code": "+61",
      "mobile_digits": "9"
    },
    {
      "country": "Austria",
      "iso2": "AT",
      "calling_code": "+43",
      "mobile_digits": "10-11"
    },
    {
      "country": "Azerbaijan",
      "iso2": "AZ",
      "calling_code": "+994",
      "mobile_digits": "9"
    },
    {
      "country": "Anguilla",
      "iso2": "AI",
      "calling_code": "+1264",
      "mobile_digits": "10"
    },
    {
      "country": "Antarctica",
      "iso2": "AQ",
      "calling_code": "+672",
      "mobile_digits": "N/A"
    },
    {
      "country": "American Samoa",
      "iso2": "AS",
      "calling_code": "+1684",
      "mobile_digits": "10"
    },
    {
      "country": "Åland Islands",
      "iso2": "AX",
      "calling_code": "+358",
      "mobile_digits": "9-10"
    },
    {
      "country": "Bouvet Island",
      "iso2": "BV",
      "calling_code": "+47",
      "mobile_digits": "N/A"
    },
    {
      "country": "Bahamas",
      "iso2": "BS",
      "calling_code": "+1242",
      "mobile_digits": "10"
    },
    {
      "country": "Bahrain",
      "iso2": "BH",
      "calling_code": "+973",
      "mobile_digits": "8"
    },
    {
      "country": "British Indian Ocean Territory",
      "iso2": "IO",
      "calling_code": "+246",
      "mobile_digits": "7"
    },
    {
      "country": "Bangladesh",
      "iso2": "BD",
      "calling_code": "+880",
      "mobile_digits": "10"
    },
    {
      "country": "Barbados",
      "iso2": "BB",
      "calling_code": "+1246",
      "mobile_digits": "10"
    },
    {
      "country": "Belarus",
      "iso2": "BY",
      "calling_code": "+375",
      "mobile_digits": "9"
    },
    {
      "country": "Belgium",
      "iso2": "BE",
      "calling_code": "+32",
      "mobile_digits": "9"
    },
    {
      "country": "Belize",
      "iso2": "BZ",
      "calling_code": "+501",
      "mobile_digits": "7"
    },
    {
      "country": "Benin",
      "iso2": "BJ",
      "calling_code": "+229",
      "mobile_digits": "8-10"
    },
    {
      "country": "Bhutan",
      "iso2": "BT",
      "calling_code": "+975",
      "mobile_digits": "8"
    },
    {
      "country": "Bolivia",
      "iso2": "BO",
      "calling_code": "+591",
      "mobile_digits": "8"
    },
    {
      "country": "Bosnia and Herzegovina",
      "iso2": "BA",
      "calling_code": "+387",
      "mobile_digits": "8-9"
    },
    {
      "country": "Botswana",
      "iso2": "BW",
      "calling_code": "+267",
      "mobile_digits": "8"
    },
    {
      "country": "Brazil",
      "iso2": "BR",
      "calling_code": "+55",
      "mobile_digits": "10-11"
    },
    {
      "country": "Brunei",
      "iso2": "BN",
      "calling_code": "+673",
      "mobile_digits": "7"
    },
    {
      "country": "Bulgaria",
      "iso2": "BG",
      "calling_code": "+359",
      "mobile_digits": "9"
    },
    {
      "country": "Burkina Faso",
      "iso2": "BF",
      "calling_code": "+226",
      "mobile_digits": "8"
    },
    {
      "country": "Burundi",
      "iso2": "BI",
      "calling_code": "+257",
      "mobile_digits": "8"
    },
    {
      "country": "Cabo Verde",
      "iso2": "CV",
      "calling_code": "+238",
      "mobile_digits": "7"
    },
    {
      "country": "Caribbean Netherlands",
      "iso2": "BQ",
      "calling_code": "+599",
      "mobile_digits": "7"
    },
    {
      "country": "Cocos (Keeling) Islands",
      "iso2": "CC",
      "calling_code": "+61",
      "mobile_digits": "9"
    },
    {
      "country": "Cook Islands",
      "iso2": "CK",
      "calling_code": "+682",
      "mobile_digits": "5"
    },
    {
      "country": "Christmas Island",
      "iso2": "CX",
      "calling_code": "+61",
      "mobile_digits": "9"
    },
    {
      "country": "Cambodia",
      "iso2": "KH",
      "calling_code": "+855",
      "mobile_digits": "8-9"
    },
    {
      "country": "Cameroon",
      "iso2": "CM",
      "calling_code": "+237",
      "mobile_digits": "9"
    },
    {
      "country": "Canada",
      "iso2": "CA",
      "calling_code": "+1",
      "mobile_digits": "10"
    },
    {
      "country": "Central African Republic",
      "iso2": "CF",
      "calling_code": "+236",
      "mobile_digits": "8"
    },
    {
      "country": "Chad",
      "iso2": "TD",
      "calling_code": "+235",
      "mobile_digits": "8"
    },
    {
      "country": "Chile",
      "iso2": "CL",
      "calling_code": "+56",
      "mobile_digits": "9"
    },
    {
      "country": "China",
      "iso2": "CN",
      "calling_code": "+86",
      "mobile_digits": "11"
    },
    {
      "country": "Colombia",
      "iso2": "CO",
      "calling_code": "+57",
      "mobile_digits": "10"
    },
    {
      "country": "Comoros",
      "iso2": "KM",
      "calling_code": "+269",
      "mobile_digits": "7"
    },
    {
      "country": "Congo (Republic of the)",
      "iso2": "CG",
      "calling_code": "+242",
      "mobile_digits": "9"
    },
    {
      "country": "Congo (DR)",
      "iso2": "CD",
      "calling_code": "+243",
      "mobile_digits": "9"
    },
    {
      "country": "Costa Rica",
      "iso2": "CR",
      "calling_code": "+506",
      "mobile_digits": "8"
    },
    {
      "country": "Croatia",
      "iso2": "HR",
      "calling_code": "+385",
      "mobile_digits": "8-9"
    },
    {
      "country": "Cuba",
      "iso2": "CU",
      "calling_code": "+53",
      "mobile_digits": "8"
    },
    {
      "country": "Cyprus",
      "iso2": "CY",
      "calling_code": "+357",
      "mobile_digits": "8"
    },
    {
      "country": "Czech Republic",
      "iso2": "CZ",
      "calling_code": "+420",
      "mobile_digits": "9"
    },
    {
      "country": "Denmark",
      "iso2": "DK",
      "calling_code": "+45",
      "mobile_digits": "8"
    },
    {
      "country": "Djibouti",
      "iso2": "DJ",
      "calling_code": "+253",
      "mobile_digits": "8"
    },
    {
      "country": "Dominica",
      "iso2": "DM",
      "calling_code": "+1767",
      "mobile_digits": "10"
    },
    {
      "country": "Dominican Republic",
      "iso2": "DO",
      "calling_code": "+1",
      "mobile_digits": "10"
    },
    {
      "country": "Ecuador",
      "iso2": "EC",
      "calling_code": "+593",
      "mobile_digits": "9"
    },
    {
      "country": "Egypt",
      "iso2": "EG",
      "calling_code": "+20",
      "mobile_digits": "10"
    },
    {
      "country": "El Salvador",
      "iso2": "SV",
      "calling_code": "+503",
      "mobile_digits": "8"
    },
    {
      "country": "Equatorial Guinea",
      "iso2": "GQ",
      "calling_code": "+240",
      "mobile_digits": "9"
    },
    {
      "country": "Eritrea",
      "iso2": "ER",
      "calling_code": "+291",
      "mobile_digits": "7"
    },
    {
      "country": "Estonia",
      "iso2": "EE",
      "calling_code": "+372",
      "mobile_digits": "7-8"
    },
    {
      "country": "Eswatini",
      "iso2": "SZ",
      "calling_code": "+268",
      "mobile_digits": "8"
    },
    {
      "country": "Ethiopia",
      "iso2": "ET",
      "calling_code": "+251",
      "mobile_digits": "9"
    },
    {
      "country": "Fiji",
      "iso2": "FJ",
      "calling_code": "+679",
      "mobile_digits": "7"
    },
    {
      "country": "Finland",
      "iso2": "FI",
      "calling_code": "+358",
      "mobile_digits": "9-10"
    },
    {
      "country": "France",
      "iso2": "FR",
      "calling_code": "+33",
      "mobile_digits": "9"
    },
    {
      "country": "Falkland Islands",
      "iso2": "FK",
      "calling_code": "+500",
      "mobile_digits": "5"
    },
    {
      "country": "French Guiana",
      "iso2": "GF",
      "calling_code": "+594",
      "mobile_digits": "9"
    },
    {
      "country": "Guadeloupe",
      "iso2": "GP",
      "calling_code": "+590",
      "mobile_digits": "9"
    },
    {
      "country": "Guam",
      "iso2": "GU",
      "calling_code": "+1671",
      "mobile_digits": "10"
    },
    {
      "country": "Gabon",
      "iso2": "GA",
      "calling_code": "+241",
      "mobile_digits": "8-9"
    },
    {
      "country": "Gambia",
      "iso2": "GM",
      "calling_code": "+220",
      "mobile_digits": "7"
    },
    {
      "country": "Georgia",
      "iso2": "GE",
      "calling_code": "+995",
      "mobile_digits": "9"
    },
    {
      "country": "Germany",
      "iso2": "DE",
      "calling_code": "+49",
      "mobile_digits": "10-11"
    },
    {
      "country": "Ghana",
      "iso2": "GH",
      "calling_code": "+233",
      "mobile_digits": "9"
    },
    {
      "country": "Greece",
      "iso2": "GR",
      "calling_code": "+30",
      "mobile_digits": "10"
    },
    {
      "country": "Grenada",
      "iso2": "GD",
      "calling_code": "+1473",
      "mobile_digits": "10"
    },
    {
      "country": "Guatemala",
      "iso2": "GT",
      "calling_code": "+502",
      "mobile_digits": "8"
    },
    {
      "country": "Guinea",
      "iso2": "GN",
      "calling_code": "+224",
      "mobile_digits": "8-9"
    },
    {
      "country": "Guinea-Bissau",
      "iso2": "GW",
      "calling_code": "+245",
      "mobile_digits": "9"
    },
    {
      "country": "Guyana",
      "iso2": "GY",
      "calling_code": "+592",
      "mobile_digits": "7"
    },
    {
      "country": "Haiti",
      "iso2": "HT",
      "calling_code": "+509",
      "mobile_digits": "8"
    },
    {
      "country": "Honduras",
      "iso2": "HN",
      "calling_code": "+504",
      "mobile_digits": "8"
    },
    {
      "country": "Hungary",
      "iso2": "HU",
      "calling_code": "+36",
      "mobile_digits": "9"
    },
    {
      "country": "Iceland",
      "iso2": "IS",
      "calling_code": "+354",
      "mobile_digits": "7"
    },
    {
      "country": "India",
      "iso2": "IN",
      "calling_code": "+91",
      "mobile_digits": "10"
    },
    {
      "country": "Indonesia",
      "iso2": "ID",
      "calling_code": "+62",
      "mobile_digits": "9-12"
    },
    {
      "country": "Iran",
      "iso2": "IR",
      "calling_code": "+98",
      "mobile_digits": "10"
    },
    {
      "country": "Iraq",
      "iso2": "IQ",
      "calling_code": "+964",
      "mobile_digits": "10"
    },
    {
      "country": "Ireland",
      "iso2": "IE",
      "calling_code": "+353",
      "mobile_digits": "9"
    },
    {
      "country": "Israel",
      "iso2": "IL",
      "calling_code": "+972",
      "mobile_digits": "9"
    },
    {
      "country": "Italy",
      "iso2": "IT",
      "calling_code": "+39",
      "mobile_digits": "9-10"
    },
    {
      "country": "Ivory Coast (Cote d'Ivoire)",
      "iso2": "CI",
      "calling_code": "+225",
      "mobile_digits": "10"
    },
    {
      "country": "Jamaica",
      "iso2": "JM",
      "calling_code": "+1876",
      "mobile_digits": "10"
    },
    {
      "country": "Japan",
      "iso2": "JP",
      "calling_code": "+81",
      "mobile_digits": "10"
    },
    {
      "country": "Jordan",
      "iso2": "JO",
      "calling_code": "+962",
      "mobile_digits": "9"
    },
    {
      "country": "Kazakhstan",
      "iso2": "KZ",
      "calling_code": "+7",
      "mobile_digits": "10"
    },
    {
      "country": "Kenya",
      "iso2": "KE",
      "calling_code": "+254",
      "mobile_digits": "9"
    },
    {
      "country": "Kiribati",
      "iso2": "KI",
      "calling_code": "+686",
      "mobile_digits": "8"
    },
    {
      "country": "Kosovo",
      "iso2": "XK",
      "calling_code": "+383",
      "mobile_digits": "8-9"
    },
    {
      "country": "Kuwait",
      "iso2": "KW",
      "calling_code": "+965",
      "mobile_digits": "8"
    },
    {
      "country": "Kyrgyzstan",
      "iso2": "KG",
      "calling_code": "+996",
      "mobile_digits": "9"
    },
    {
      "country": "Laos",
      "iso2": "LA",
      "calling_code": "+856",
      "mobile_digits": "9-10"
    },
    {
      "country": "Latvia",
      "iso2": "LV",
      "calling_code": "+371",
      "mobile_digits": "8"
    },
    {
      "country": "Lebanon",
      "iso2": "LB",
      "calling_code": "+961",
      "mobile_digits": "7-8"
    },
    {
      "country": "Lesotho",
      "iso2": "LS",
      "calling_code": "+266",
      "mobile_digits": "8"
    },
    {
      "country": "Liberia",
      "iso2": "LR",
      "calling_code": "+231",
      "mobile_digits": "7-8"
    },
    {
      "country": "Libya",
      "iso2": "LY",
      "calling_code": "+218",
      "mobile_digits": "9"
    },
    {
      "country": "Liechtenstein",
      "iso2": "LI",
      "calling_code": "+423",
      "mobile_digits": "7"
    },
    {
      "country": "Lithuania",
      "iso2": "LT",
      "calling_code": "+370",
      "mobile_digits": "8"
    },
    {
      "country": "Luxembourg",
      "iso2": "LU",
      "calling_code": "+352",
      "mobile_digits": "9"
    },
    {
      "country": "Martinique",
      "iso2": "MQ",
      "calling_code": "+596",
      "mobile_digits": "9"
    },
    {
      "country": "Montserrat",
      "iso2": "MS",
      "calling_code": "+1664",
      "mobile_digits": "10"
    },
    {
      "country": "Madagascar",
      "iso2": "MG",
      "calling_code": "+261",
      "mobile_digits": "9"
    },
    {
      "country": "Malawi",
      "iso2": "MW",
      "calling_code": "+265",
      "mobile_digits": "9"
    },
    {
      "country": "Malaysia",
      "iso2": "MY",
      "calling_code": "+60",
      "mobile_digits": "9-10"
    },
    {
      "country": "Maldives",
      "iso2": "MV",
      "calling_code": "+960",
      "mobile_digits": "7"
    },
    {
      "country": "Mali",
      "iso2": "ML",
      "calling_code": "+223",
      "mobile_digits": "8"
    },
    {
      "country": "Malta",
      "iso2": "MT",
      "calling_code": "+356",
      "mobile_digits": "8"
    },
    {
      "country": "Marshall Islands",
      "iso2": "MH",
      "calling_code": "+692",
      "mobile_digits": "7"
    },
    {
      "country": "Mauritania",
      "iso2": "MR",
      "calling_code": "+222",
      "mobile_digits": "8"
    },
    {
      "country": "Mauritius",
      "iso2": "MU",
      "calling_code": "+230",
      "mobile_digits": "8"
    },
    {
      "country": "Mexico",
      "iso2": "MX",
      "calling_code": "+52",
      "mobile_digits": "10"
    },
    {
      "country": "Micronesia",
      "iso2": "FM",
      "calling_code": "+691",
      "mobile_digits": "7"
    },
    {
      "country": "Moldova",
      "iso2": "MD",
      "calling_code": "+373",
      "mobile_digits": "8"
    },
    {
      "country": "Monaco",
      "iso2": "MC",
      "calling_code": "+377",
      "mobile_digits": "8-9"
    },
    {
      "country": "Mongolia",
      "iso2": "MN",
      "calling_code": "+976",
      "mobile_digits": "8"
    },
    {
      "country": "Montenegro",
      "iso2": "ME",
      "calling_code": "+382",
      "mobile_digits": "8"
    },
    {
      "country": "Morocco",
      "iso2": "MA",
      "calling_code": "+212",
      "mobile_digits": "9"
    },
    {
      "country": "Mozambique",
      "iso2": "MZ",
      "calling_code": "+258",
      "mobile_digits": "9"
    },
    {
      "country": "Myanmar",
      "iso2": "MM",
      "calling_code": "+95",
      "mobile_digits": "8-10"
    },
    {
      "country": "Namibia",
      "iso2": "NA",
      "calling_code": "+264",
      "mobile_digits": "9"
    },
    {
      "country": "Nauru",
      "iso2": "NR",
      "calling_code": "+674",
      "mobile_digits": "7"
    },
    {
      "country": "Nepal",
      "iso2": "NP",
      "calling_code": "+977",
      "mobile_digits": "10"
    },
    {
      "country": "Netherlands",
      "iso2": "NL",
      "calling_code": "+31",
      "mobile_digits": "9"
    },
    {
      "country": "New Zealand",
      "iso2": "NZ",
      "calling_code": "+64",
      "mobile_digits": "8-10"
    },
    {
      "country": "Nicaragua",
      "iso2": "NI",
      "calling_code": "+505",
      "mobile_digits": "8"
    },
    {
      "country": "Niger",
      "iso2": "NE",
      "calling_code": "+227",
      "mobile_digits": "8"
    },
    {
      "country": "Nigeria",
      "iso2": "NG",
      "calling_code": "+234",
      "mobile_digits": "10"
    },
    {
      "country": "North Korea",
      "iso2": "KP",
      "calling_code": "+850",
      "mobile_digits": "10"
    },
    {
      "country": "North Macedonia",
      "iso2": "MK",
      "calling_code": "+389",
      "mobile_digits": "8"
    },
    {
      "country": "Norway",
      "iso2": "NO",
      "calling_code": "+47",
      "mobile_digits": "8"
    },
    {
      "country": "Oman",
      "iso2": "OM",
      "calling_code": "+968",
      "mobile_digits": "8"
    },
    {
      "country": "Pakistan",
      "iso2": "PK",
      "calling_code": "+92",
      "mobile_digits": "10"
    },
    {
      "country": "Palau",
      "iso2": "PW",
      "calling_code": "+680",
      "mobile_digits": "7"
    },
    {
      "country": "Palestine",
      "iso2": "PS",
      "calling_code": "+970",
      "mobile_digits": "9"
    },
    {
      "country": "Panama",
      "iso2": "PA",
      "calling_code": "+507",
      "mobile_digits": "8"
    },
    {
      "country": "Papua New Guinea",
      "iso2": "PG",
      "calling_code": "+675",
      "mobile_digits": "8"
    },
    {
      "country": "Paraguay",
      "iso2": "PY",
      "calling_code": "+595",
      "mobile_digits": "9"
    },
    {
      "country": "Peru",
      "iso2": "PE",
      "calling_code": "+51",
      "mobile_digits": "9"
    },
    {
      "country": "Philippines",
      "iso2": "PH",
      "calling_code": "+63",
      "mobile_digits": "10"
    },
    {
      "country": "Poland",
      "iso2": "PL",
      "calling_code": "+48",
      "mobile_digits": "9"
    },
    {
      "country": "Portugal",
      "iso2": "PT",
      "calling_code": "+351",
      "mobile_digits": "9"
    },
    {
      "country": "Qatar",
      "iso2": "QA",
      "calling_code": "+974",
      "mobile_digits": "8"
    },
    {
      "country": "Romania",
      "iso2": "RO",
      "calling_code": "+40",
      "mobile_digits": "9"
    },
    {
      "country": "Russia",
      "iso2": "RU",
      "calling_code": "+7",
      "mobile_digits": "10"
    },
    {
      "country": "Rwanda",
      "iso2": "RW",
      "calling_code": "+250",
      "mobile_digits": "9"
    },
    {
      "country": "Saint Kitts and Nevis",
      "iso2": "KN",
      "calling_code": "+1869",
      "mobile_digits": "10"
    },
    {
      "country": "Saint Lucia",
      "iso2": "LC",
      "calling_code": "+1758",
      "mobile_digits": "10"
    },
    {
      "country": "Saint Vincent and the Grenadines",
      "iso2": "VC",
      "calling_code": "+1784",
      "mobile_digits": "10"
    },
    {
      "country": "Samoa",
      "iso2": "WS",
      "calling_code": "+685",
      "mobile_digits": "6-7"
    },
    {
      "country": "San Marino",
      "iso2": "SM",
      "calling_code": "+378",
      "mobile_digits": "6-10"
    },
    {
      "country": "Sao Tome and Principe",
      "iso2": "ST",
      "calling_code": "+239",
      "mobile_digits": "7"
    },
    {
      "country": "Saudi Arabia",
      "iso2": "SA",
      "calling_code": "+966",
      "mobile_digits": "9"
    },
    {
      "country": "Senegal",
      "iso2": "SN",
      "calling_code": "+221",
      "mobile_digits": "9"
    },
    {
      "country": "Serbia",
      "iso2": "RS",
      "calling_code": "+381",
      "mobile_digits": "8-9"
    },
    {
      "country": "Seychelles",
      "iso2": "SC",
      "calling_code": "+248",
      "mobile_digits": "7"
    },
    {
      "country": "Sierra Leone",
      "iso2": "SL",
      "calling_code": "+232",
      "mobile_digits": "8"
    },
    {
      "country": "Singapore",
      "iso2": "SG",
      "calling_code": "+65",
      "mobile_digits": "8"
    },
    {
      "country": "Slovakia",
      "iso2": "SK",
      "calling_code": "+421",
      "mobile_digits": "9"
    },
    {
      "country": "Slovenia",
      "iso2": "SI",
      "calling_code": "+386",
      "mobile_digits": "8"
    },
    {
      "country": "Solomon Islands",
      "iso2": "SB",
      "calling_code": "+677",
      "mobile_digits": "7"
    },
    {
      "country": "Somalia",
      "iso2": "SO",
      "calling_code": "+252",
      "mobile_digits": "8-9"
    },
    {
      "country": "South Africa",
      "iso2": "ZA",
      "calling_code": "+27",
      "mobile_digits": "9"
    },
    {
      "country": "South Korea",
      "iso2": "KR",
      "calling_code": "+82",
      "mobile_digits": "9-10"
    },
    {
      "country": "South Sudan",
      "iso2": "SS",
      "calling_code": "+211",
      "mobile_digits": "9"
    },
    {
      "country": "Spain",
      "iso2": "ES",
      "calling_code": "+34",
      "mobile_digits": "9"
    },
    {
      "country": "Sri Lanka",
      "iso2": "LK",
      "calling_code": "+94",
      "mobile_digits": "9"
    },
    {
      "country": "Sudan",
      "iso2": "SD",
      "calling_code": "+249",
      "mobile_digits": "9"
    },
    {
      "country": "Suriname",
      "iso2": "SR",
      "calling_code": "+597",
      "mobile_digits": "7"
    },
    {
      "country": "Sweden",
      "iso2": "SE",
      "calling_code": "+46",
      "mobile_digits": "9"
    },
    {
      "country": "Switzerland",
      "iso2": "CH",
      "calling_code": "+41",
      "mobile_digits": "9"
    },
    {
      "country": "Syria",
      "iso2": "SY",
      "calling_code": "+963",
      "mobile_digits": "9"
    },
    {
      "country": "Taiwan",
      "iso2": "TW",
      "calling_code": "+886",
      "mobile_digits": "9"
    },
    {
      "country": "Tajikistan",
      "iso2": "TJ",
      "calling_code": "+992",
      "mobile_digits": "9"
    },
    {
      "country": "Tanzania",
      "iso2": "TZ",
      "calling_code": "+255",
      "mobile_digits": "9"
    },
    {
      "country": "Thailand",
      "iso2": "TH",
      "calling_code": "+66",
      "mobile_digits": "9"
    },
    {
      "country": "Timor-Leste",
      "iso2": "TL",
      "calling_code": "+670",
      "mobile_digits": "8"
    },
    {
      "country": "Togo",
      "iso2": "TG",
      "calling_code": "+228",
      "mobile_digits": "8"
    },
    {
      "country": "Tonga",
      "iso2": "TO",
      "calling_code": "+676",
      "mobile_digits": "7"
    },
    {
      "country": "Trinidad and Tobago",
      "iso2": "TT",
      "calling_code": "+1868",
      "mobile_digits": "10"
    },
    {
      "country": "Tunisia",
      "iso2": "TN",
      "calling_code": "+216",
      "mobile_digits": "8"
    },
    {
      "country": "Turkey",
      "iso2": "TR",
      "calling_code": "+90",
      "mobile_digits": "10"
    },
    {
      "country": "Turkmenistan",
      "iso2": "TM",
      "calling_code": "+993",
      "mobile_digits": "8"
    },
    {
      "country": "Tuvalu",
      "iso2": "TV",
      "calling_code": "+688",
      "mobile_digits": "5-6"
    },
    {
      "country": "Uganda",
      "iso2": "UG",
      "calling_code": "+256",
      "mobile_digits": "9"
    },
    {
      "country": "Ukraine",
      "iso2": "UA",
      "calling_code": "+380",
      "mobile_digits": "9"
    },
    {
      "country": "United Arab Emirates",
      "iso2": "AE",
      "calling_code": "+971",
      "mobile_digits": "9"
    },
    {
      "country": "United Kingdom",
      "iso2": "GB",
      "calling_code": "+44",
      "mobile_digits": "10"
    },
    {
      "country": "United States",
      "iso2": "US",
      "calling_code": "+1",
      "mobile_digits": "10"
    },
    {
      "country": "Uruguay",
      "iso2": "UY",
      "calling_code": "+598",
      "mobile_digits": "8"
    },
    {
      "country": "Uzbekistan",
      "iso2": "UZ",
      "calling_code": "+998",
      "mobile_digits": "9"
    },
    {
      "country": "Vanuatu",
      "iso2": "VU",
      "calling_code": "+678",
      "mobile_digits": "7"
    },
    {
      "country": "Vatican City",
      "iso2": "VA",
      "calling_code": "+39",
      "mobile_digits": "10"
    },
    {
      "country": "Venezuela",
      "iso2": "VE",
      "calling_code": "+58",
      "mobile_digits": "10"
    },
    {
      "country": "Vietnam",
      "iso2": "VN",
      "calling_code": "+84",
      "mobile_digits": "9-10"
    },
    {
      "country": "Yemen",
      "iso2": "YE",
      "calling_code": "+967",
      "mobile_digits": "9"
    },
    {
      "country": "Zambia",
      "iso2": "ZM",
      "calling_code": "+260",
      "mobile_digits": "9"
    },
    {
      "country": "Zimbabwe",
      "iso2": "ZW",
      "calling_code": "+263",
      "mobile_digits": "9"
    },
    {
      "country": "Hong Kong",
      "iso2": "HK",
      "calling_code": "+852",
      "mobile_digits": "8"
    },
    {
      "country": "Macau",
      "iso2": "MO",
      "calling_code": "+853",
      "mobile_digits": "8"
    },
    {
      "country": "Puerto Rico",
      "iso2": "PR",
      "calling_code": "+1787",
      "mobile_digits": "10"
    },
    {
      "country": "Greenland",
      "iso2": "GL",
      "calling_code": "+299",
      "mobile_digits": "6"
    },
    {
      "country": "French Southern Territories",
      "iso2": "TF",
      "calling_code": "+262",
      "mobile_digits": "N/A"
    },
    {
      "country": "Faroe Islands",
      "iso2": "FO",
      "calling_code": "+298",
      "mobile_digits": "6"
    },
    {
      "country": "Gibraltar",
      "iso2": "GI",
      "calling_code": "+350",
      "mobile_digits": "8"
    },
    {
      "country": "Bermuda",
      "iso2": "BM",
      "calling_code": "+1441",
      "mobile_digits": "10"
    },
    {
      "country": "Cayman Islands",
      "iso2": "KY",
      "calling_code": "+1345",
      "mobile_digits": "10"
    },
    {
      "country": "Isle of Man",
      "iso2": "IM",
      "calling_code": "+44",
      "mobile_digits": "10"
    },
    {
      "country": "Jersey",
      "iso2": "JE",
      "calling_code": "+44",
      "mobile_digits": "10"
    },
    {
      "country": "Guernsey",
      "iso2": "GG",
      "calling_code": "+44",
      "mobile_digits": "10"
    },
    {
      "country": "New Caledonia",
      "iso2": "NC",
      "calling_code": "+687",
      "mobile_digits": "6"
    },
    {
      "country": "French Polynesia",
      "iso2": "PF",
      "calling_code": "+689",
      "mobile_digits": "6-8"
    },
    {
      "country": "Aruba",
      "iso2": "AW",
      "calling_code": "+297",
      "mobile_digits": "7"
    },
    {
      "country": "Curacao",
      "iso2": "CW",
      "calling_code": "+599",
      "mobile_digits": "7"
    },
    {
      "country": "Western Sahara",
      "iso2": "EH",
      "calling_code": "+212",
      "mobile_digits": "9"
    },
    {
      "country": "Saint Barthélemy",
      "iso2": "BL",
      "calling_code": "+590",
      "mobile_digits": "9"
    },
    {
      "country": "South Georgia and the South Sandwich Islands",
      "iso2": "GS",
      "calling_code": "+500",
      "mobile_digits": "N/A"
    },
  
    {
      "country": "Heard Island and McDonald Islands",
      "iso2": "HM",
      "calling_code": "+672",
      "mobile_digits": "N/A"
    },
  
    {
      "country": "Saint Martin (French part)",
      "iso2": "MF",
      "calling_code": "+590",
      "mobile_digits": "9"
    },
    {
      "country": "Northern Mariana Islands",
      "iso2": "MP",
      "calling_code": "+1670",
      "mobile_digits": "10"
    },
    {
      "country": "Norfolk Island",
      "iso2": "NF",
      "calling_code": "+672",
      "mobile_digits": "6"
    },
    {
      "country": "Niue",
      "iso2": "NU",
      "calling_code": "+683",
      "mobile_digits": "4"
    },
    {
      "country": "Saint Pierre and Miquelon",
      "iso2": "PM",
      "calling_code": "+508",
      "mobile_digits": "6"
    },
    {
      "country": "Pitcairn Islands",
      "iso2": "PN",
      "calling_code": "+64",
      "mobile_digits": "7"
    },
    {
      "country": "Réunion",
      "iso2": "RE",
      "calling_code": "+262",
      "mobile_digits": "9"
    },
    {
      "country": "Saint Helena, Ascension and Tristan da Cunha",
      "iso2": "SH",
      "calling_code": "+290",
      "mobile_digits": "4"
    },
    {
      "country": "Svalbard and Jan Mayen",
      "iso2": "SJ",
      "calling_code": "+47",
      "mobile_digits": "8"
    },
    {
      "country": "Sint Maarten (Dutch part)",
      "iso2": "SX",
      "calling_code": "+1721",
      "mobile_digits": "10"
    },
    {
      "country": "Turks and Caicos Islands",
      "iso2": "TC",
      "calling_code": "+1649",
      "mobile_digits": "10"
    },
  
    {
      "country": "Tokelau",
      "iso2": "TK",
      "calling_code": "+690",
      "mobile_digits": "4"
    },
    {
      "country": "United States Minor Outlying Islands",
      "iso2": "UM",
      "calling_code": "+1",
      "mobile_digits": "10"
    },
    {
      "country": "British Virgin Islands",
      "iso2": "VG",
      "calling_code": "+1284",
      "mobile_digits": "10"
    },
    {
      "country": "U.S. Virgin Islands",
      "iso2": "VI",
      "calling_code": "+1340",
      "mobile_digits": "10"
    },
    {
      "country": "Wallis and Futuna",
      "iso2": "WF",
      "calling_code": "+681",
      "mobile_digits": "6"
    },
    {
      "country": "Mayotte",
      "iso2": "YT",
      "calling_code": "+262",
      "mobile_digits": "9"
    }
]

export default COUNTRY_CODES